import axios from "axios";
import {
    KPI_STATUS_SUCCESS,
    KPI_STATUS_ERROR,
    KPI_STATUS_REQUEST,
} from "./../../../constants/closeLoop/kpiDashboard/kpiEvaluationStatusConstant";

export const IndividualScenarioKPIEvaluation = (payload) => (dispatch) => {
    try {
        console.log("payload in action", payload);
        dispatch({
            type: KPI_STATUS_REQUEST,
        });
        const Url = `/get/individual/scenario/all/kpi_status?scenario_uuid=${payload}`;
        return axios
            .get(Url)
            .then((response) => {
                if (response) {
                    if (response && response.status === 200) {
                        const { data } = response;
                        dispatch({ type: KPI_STATUS_SUCCESS, payload: data });
                    } else {
                        const { data } = response;
                        dispatch({
                            type: KPI_STATUS_ERROR,
                            payload: data.message,
                        });
                    }
                } else {
                    dispatch({
                        type: KPI_STATUS_ERROR,
                        payload: response,
                    });
                }
            })
            .catch((error) => {
                // dispatch({
                //     type: KPI_STATUS_ERROR,
                //     payload: error.message,
                // });
                // if(error.hasOwnProperty("response") && error.response.hasOwnProperty("data")
                //     && error.response.data.hasOwnProperty("message")){
                if (
                    Object.prototype.hasOwnProperty.call(error, "response") &&
                    Object.prototype.hasOwnProperty.call(error.response, "data") &&
                    Object.prototype.hasOwnProperty.call(error.response.data, "message")
                ) {
                    dispatch({ type: KPI_STATUS_ERROR, payload: error.response.data.message });
                } else {
                    dispatch({
                        type: KPI_STATUS_ERROR,
                        payload: "Something Went Wrong, Please Try Again!!",
                    });
                }
            });
    } catch (error) {
        console.log(error);
        dispatch({ type: KPI_STATUS_ERROR, payload: error.message });
    }
};
